
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import SearchBoxModal from "../component/SearchBoxModal";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

export default function DanhSachPhongHop() {
    const { user } = useSelector((state) => state.auth);
    const [showModal, setShowModal] = useState(false)
    const [roomSelect, setRoomSelect] = useState(null)
    const [refresh, setRefresh] = useState(false)

    let columns = [
        { name: "id", label: "ID" },
        { name: "title", label: "Tên phòng họp" },
        {
            name: "aprover_id", label: "Quản lý phòng",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="w-100" style={{ minWidth: 200 }}>
                        <div className="input-group mb-3">
                            <input type="text" className="form-control height32" value={tableMeta.aprover_name} readOnly placeholder={tableMeta.aprover_name} aria-label="Username" aria-describedby="basic-addon1" />
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-sm btn-success height32" onClick={() => { setShowModal(true); setRoomSelect(tableMeta) }}>Thay đổi </button>
                            </div>
                        </div>
                    </div>
                },
            }
        },
        { name: "address", label: "Địa chỉ" },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) return <span className="text-success">Đang hoạt động</span>
                    if (value == 0) return <span className="text-danger">Không hoạt động</span>
                    return null
                },
            }
        },
        { name: "author", label: "Người tạo" },
    ];

    const changeApprover = (uid) => {
        let values = { aprover_id: uid }
        confirmAlert({
            title: 'Thành công',
            message: 'Bạn muốn thay đổi quản lý phòng họp ?',
            buttons: [{
                label: 'OK', onClick: () => {
                    Axios.put(URL_LIST_ALL + 'rooms/' + roomSelect.id, values, user.config).then(res => {
                        if (res.data.status === "success") {
                            confirmAlert({
                                title: 'Thành công',
                                message: 'Thay đổi thành công',
                                buttons: [{ label: 'OK' }]
                            });
                            setRoomSelect(null)
                            setRefresh(!refresh)
                            setShowModal(false)
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));

                }

            }, { label: 'Hủy' }]
        });

    }

    return (<AkkhorLayout idrole="dashboard">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Quản lý phòng họp
                </li>
            </ul>
        </div>

        <SRList name="rooms" idrole="quan-ly-phong-hop" params={''} title="" defaultLimit={10} serverSide={true} columns={columns} refresh={refresh} />
        <Modal show={showModal} onHide={() => setShowModal(false)} animation={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Thay đổi quản lý phòng họp: {roomSelect && roomSelect.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {roomSelect &&
                    <SearchBoxModal apiname={"users"} placeholder="Chọn người quản lý" colvalue={'id'} colname={'fullname'}
                        defaultValue={roomSelect.aprover_id} name='aprover_id'
                        onChange={async (e) => {
                            changeApprover(e)
                        }} />
                }
            </Modal.Body>
        </Modal>
    </AkkhorLayout>);
}
